{
  "checkedInTitle": "Anda sudah check-in",
  "postCheckInInstructions": "Instruksi setelah check-in",
  "appointmentDetails": "Detail janji temu",
  "notifyWarehouse": "Kami telah memberi tahu gudang bahwa Anda sudah tiba agar mereka dapat memeriksa ketersediaan",
  "waitForStaff": "Harap tunggu instruksi lebih lanjut dari staf gudang",
  "unplannedDescription": "Sepertinya Anda tidak memiliki janji temu. Harap tunggu instruksi lebih lanjut dari staf gudang.",
  "whatsappDelay": "Pesan WhatsApp pertama mungkin memerlukan waktu hingga satu menit untuk tiba.",
  "bookNextTitle": "Buat janji temu untuk kunjungan berikutnya",
  "bookNextBody": "Daftar ke Opendock agar Anda dapat membuat janji temu saat berikutnya datang ke fasilitas ini",
  "helpFooter": "Jika Anda memerlukan bantuan atau informasi tambahan, silakan hubungi staf gudang",
  "finalize": "Selesai ({seconds})"
}
